<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div v-if="open">
    <v-overlay
        z-index="50"
    ></v-overlay>

    <v-navigation-drawer
        absolute class="view"
        permanent
        right
        width="1000"
    >
      <!--<v-card>-->

      <v-content>

        <div class="contents">
          <v-card>
            <v-container class="container--fluid">
              <v-row>
                <v-col class="" v-if="route">

                  <!--                  ทะเบียน {{ route.results && route.results.truck && route.results.truck.plate }}-->
                  <v-select
                      v-model="route.truck_id"
                      :items="trucks.map(truck => {return {value:truck.id , text:`${truck.plate}: ${truck.name}`}})"
                      :loading="isLoadCalculateRoute"
                      class="mb-1"
                      hide-details
                      label="รถบรรทุก"
                      outlined
                      required
                      @change="isDirty = true"
                  ></v-select>

                  <!--                  :-->
                  <!--                  <TypeBadge v-if="route.customer" :small="true" :type="route.customer.type"></TypeBadge>-->
                  <!--                  {{ route.customer && route.customer_code }}-->

                  เบี้ยเลี้ยง {{ $helper.number_format(route.driver_cost) }} บาท
                  (โอที {{ $helper.number_format(route.ot_cost) }} บาท)<br/>
                  ที่พัก {{ $helper.number_format(route.accommodation_cost) }} บาท
                  {{
                    route && route.results && route.results.optimized && route.results.optimized.filter(data => data.action == 'REST').length > 0 ? '(' + route.results.optimized.filter(data => data.action == 'REST').length + ' คืน)' : ''
                  }}<br/>
                  น้ำมัน {{ $helper.number_format(route.fuel_cost) }} บาท
                  ทางด่วน {{ $helper.number_format(route.motorway_cost) }} บาท<br/>

                </v-col>
                <v-col class="col-6" v-if="route">

                  ขึ้นของ
                  <v-btn :loading="isLoadCalculateRoute" class="delta-text input-text" outlined small
                         tile
                         @click="$root.$emit('openDateTimePicker',{datetime:route.load_at,onApply:datetime=>route.load_at=datetime})"
                  >
                    {{ $helper.date_format_short_with_time(route.load_at) }}


                  </v-btn>
                  เริ่มส่งของ
                  <v-btn :loading="isLoadCalculateRoute" class="delta-text input-text" outlined small
                         tile
                         @click="$root.$emit('openDateTimePicker',{datetime:route.start_at,onApply:datetime=>{route.start_at=datetime;isDirty = true}})"
                  >
                    {{ $helper.date_format_short_with_time(route.start_at) }}

                  </v-btn>
                  -{{
                    $helper.date_format_short(route.end_at)
                  }}
                  <br/>
                  ระยะทาง {{ $helper.number_format(route.total_distance, 0) }} km
                  <br/>
                  ลูกค้า
                  {{
                    route && route.results && route.results.optimized && route.results.optimized.filter(data => data.action == 'UNLOAD' && data.code != 'base').length > 0 ? route.results.optimized.filter(data => data.action == 'UNLOAD' && data.code != 'base').length : ''
                  }}
                  ราย<br/>

                  ปริมาตร {{ $helper.number_format(route.total_volume_cbm) }}cbm น้ำหนัก {{
                    $helper.number_format(route.total_weight_kg, 0)
                  }}kg <br/>

                  มูลค่า {{ $helper.number_format(route.total_worth, 0) }}
                  <span v-if="ref_route && route && Math.round(ref_route.total_worth)!==Math.round(route.total_worth)">
                    <span v-if="ref_route.total_worth<route.total_worth" style="color:#009900">
                      (+{{ Math.round(route.total_worth - ref_route.total_worth) }})
                    </span>
                    <span v-else style="color: red">
                      (-{{ Math.round(ref_route.total_worth - route.total_worth) }})
                    </span>
                  </span>


                  บาท
                  ค่าใช้จ่าย {{ $helper.number_format(route.total_cost, 0) }}

                  <span v-if="ref_route && route && Math.round(ref_route.total_cost)!==Math.round(route.total_cost)">
                    <span v-if="ref_route.total_cost<route.total_cost" style="color: red">
                      (+{{ Math.round(route.total_cost - ref_route.total_cost) }})
                    </span>
                    <span v-else style="color:#009900">
                      (-{{ Math.round(ref_route.total_cost - route.total_cost) }})
                    </span>
                  </span>


                  บาท
                  <span v-if="ref_route && route" :style="{
                    color:route.total_cost / route.total_worth > ref_route.total_cost / ref_route.total_worth?'red':
                    route.total_cost / route.total_worth == ref_route.total_cost / ref_route.total_worth?'':'#009900'
                  }">
                  ({{ $helper.number_format(route.total_cost / route.total_worth * 100) }}%)
                  </span>

                </v-col>
              </v-row>

            </v-container>
          </v-card>
          <!--{{route}}-->
          <v-container fluid>
            <v-row>
              <v-col cols="4"
                     class="order-list"
                     style="padding: 30px 30px 30px 40px; border-right: 2px solid #ccc;"
              >
                <draggable
                    :animation="200"
                    :list="optimized"
                    :move="checkMove"
                    class="list-group"
                    ghost-class="ghost"
                    @end="dragging = false"
                    @start="dragging = true"
                >
                  <transition-group type="transition">
                    <div v-for="(action,index) in optimized"
                         :key="action.code"
                         style="position: relative"
                    >
                      <v-btn absolute fab float
                             left style="margin-left: -30px;margin-top: -18px"
                             x-small
                             @click="add(index)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn
                          class="pa-1 ma-1 caption"
                          style="height: auto"
                          width="100%"
                      >
                        {{ index + 1 }}.
                        {{ action.code }} ({{ $helper.number_format(action.worth, 0) }})
                        <br/>


                        {{
                          route && route.districts && route.districts[action.district_id] && route.districts[action.district_id]['name']
                        }}
                        /{{
                          route && route.districts && route.districts[action.district_id] && route.districts[action.district_id]['city']['name']
                        }}/{{
                          route && route.districts && route.districts[action.district_id] && route.districts[action.district_id]['province']['name']
                        }}


                      </v-btn>
                      <v-btn absolute fab float
                             right style="margin-right: -20px;top: 50%;margin-top: -15px;right: 0;"
                             x-small
                             @click="remove(index)"
                      >
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                  </transition-group>

                </draggable>

                <div style="position: relative"
                >
                  <v-btn absolute fab float
                         left style="margin-left: -30px;margin-top: -18px"
                         x-small
                         @click="add(optimized.length)"
                  >
                    <v-icon>mdi-plus</v-icon>

                  </v-btn>
                </div>
              </v-col>
              <v-col class="path-list">

                <v-simple-table v-if="route && route.results" class="itemTable">
                  <template v-slot:default>
                    <!--              <thead>-->
                    <!--              <tr class="ItemHead">-->
                    <!--                <th class="text-left">รายการ</th>-->
                    <!--                <th class="text-right">ชิ้น</th>-->
                    <!--                <th class="text-right">น้ำหนัก</th>-->
                    <!--                <th class="text-right">ปริมาตร</th>-->
                    <!--                <th class="text-right">มูลค่า</th>-->
                    <!--              </tr>-->
                    <!--              </thead>-->
                    <tbody v-for="(action, index) in route.results.optimized"
                           :key="index"
                           :currentIndex="index"
                           class="ItemRow"
                    >
                    <tr v-if="action.action==='LOAD'">
                      <td colspan="5">ขนสินค้าขึ้นรถ {{
                          $helper.date_format_short_with_time(route.load_at)
                        }}
                      </td>
                    </tr>
                    <tr v-else-if="action.action==='UNLOAD' && action.code!='base'">
                      <td style="vertical-align: top;width: 150px">{{ $helper.date_format_time(action.datetime_from) }}
                        -
                        {{ $helper.date_format_time(action.datetime_to) }}
                      </td>
                      <td colspan="4" style="vertical-align: top">{{ action.code }}
                        ({{ $helper.date_format_short(route.orders[action.code]['date_delivery']) }})
                      </td>
                      <!--                <td style="text-align: right">นน. {{ $helper.number_format(action.weight, 1, 1) }}kg</td>-->
                      <!--                <td style="text-align: right">cbm. {{ $helper.number_format(action.volume, 2, 2) }}</td>-->
                      <!--                <td style="text-align: right">มูลค่า {{ $helper.number_format(action.worth, 2, 2) }}บาท</td>-->
                    </tr>
                    <tr v-else-if="action.action==='UNLOAD' && action.code=='base'">

                      <td colspan="5" style="vertical-align: top">กลับที่พักเชียงใหม่<br/>
                      </td>
                      <!--                <td style="text-align: right">นน. {{ $helper.number_format(action.weight, 1, 1) }}kg</td>-->
                      <!--                <td style="text-align: right">cbm. {{ $helper.number_format(action.volume, 2, 2) }}</td>-->
                      <!--                <td style="text-align: right">มูลค่า {{ $helper.number_format(action.worth, 2, 2) }}บาท</td>-->
                    </tr>
                    <tr v-else-if="action.action==='DRIVE'">
                      <td style="vertical-align: top">{{ $helper.date_format_time(action.datetime_from) }} -
                        {{ $helper.date_format_time(action.datetime_to) }}
                      </td>
                      <td style="vertical-align: top">ขับรถจาก
                        {{
                          route.districts[action.code.split('-')[0]]['name']
                        }}/{{
                          route.districts[action.code.split('-')[0]]['city']['name']
                        }}/{{ route.districts[action.code.split('-')[0]]['province']['name'] }}
                        <br/>
                        ไป
                        {{
                          route.districts[action.code.split('-')[1]]['name']
                        }}/{{
                          route.districts[action.code.split('-')[1]]['city']['name']
                        }}/{{ route.districts[action.code.split('-')[1]]['province']['name'] }}

                      </td>
                      <td colspan="3" style="text-align: right;vertical-align: top">ระยะทาง. {{
                          $helper.number_format(action.distance, 1, 1)
                        }}km
                      </td>
                    </tr>
                    <tr v-else-if="action.action==='LUNCH'">
                      <td colspan="1" style="vertical-align: top">พักกลางวัน
                      </td>
                      <td colspan="4" style="vertical-align: top"></td>
                    </tr>
                    <tr v-else-if="action.action==='REST'">
                      <td colspan="1" style="vertical-align: top">พักค้างคืน
                      </td>
                      <td colspan="4" style="vertical-align: top"> {{ route.provinces[action.code]['name'] }}</td>
                    </tr>
                    <tr v-else>
                      <td>{{ action.action }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>


              </v-col>

            </v-row>
          </v-container>
        </div>
      </v-content>
      <v-btn
          v-if="isDirty || isLoadCalculateRoute"
          :loading="isLoadCalculateRoute" bottom class="close-button primary" fixed float right
          style="margin-right: 780px;bottom: 18px"
          tiled
          x-large
          @click="confirmRecalPath()"

      >
        คำนวน+เรียงใหม่
      </v-btn>

      <v-btn
          v-if="isDirty || isLoadCalculateRoute"
          :loading="isLoadCalculateRoute" bottom class="close-button primary" fixed float right
          style="margin-right: 300px;bottom: 18px"
          tiled
          x-large
          @click="ImportDraft()"

      >
        คำนวน
      </v-btn>

      <v-btn
          :disabled="isLoadCalculateRoute || isDirty"
          :loading="isLoadSubmitRoute"
          bottom class="close-button primary" fixed float right
          style="margin-right: 100px;bottom: 18px"
          tiled
          x-large
          @click="ConfirmRoute()"

      >
        ยืนยัน
      </v-btn>


      <v-btn bottom class="close-button" color="primary" fab fixed float
             right
             @click="()=>{this.close()}">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!--</v-card>-->
      <!--</v-dialog>-->
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.3;
  //background: #c8ebfb;
  //margin-top: 10px;
  //margin-bottom: 10px;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.contents {
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_iframe {
  width: 100%;
  broute: 0;
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_share {
  margin-bottom: 90px;
}

.headline {
  padding-top: 20px;
  padding-bottom: 0;
  height: 56px;
}

.headline_status {
  margin-left: 10px;
}

.overlay {
  z-index: 50 !important;
}

.view {
  z-index: 60 !important;

  .v-card__title {
    padding-left: 68px;
    padding-right: 68px;
  }

  .v-app-bar {
    padding-right: 96px;
  }
}

.item-qty {
  min-width: 80px;
}

.list-container {
  .list-row {
    position: relative;
    height: auto;
    margin-left: 0;
  }

  .list-row {
    font-size: 20px;
  }

  @media all and (max-width: 599px) {
    .list-row {
      font-size: 16px;
    }
  }
  @media all and (min-width: 600px) and (max-width: 720px) {
    .list-row {
      font-size: 18px;
    }
  }
  @media all and (min-width: 720px) and (max-width: 960px) {
    .list-row {
      font-size: 20px;
    }
  }
}

.itemTable {

  line-height: 1.2;
}

.ItemHead {
  th {
    font-size: 16px;
  }
}

.ItemRow {
  td {
    font-size: 16px;
    padding: 0 4px;
  }

  td:first-child {
    font-size: 16px;
    padding-left: 8px;
  }

  td:last-child {
    padding-right: 8px;
  }

}

.path-list {
  max-height: calc(100vh - 275px);
  overflow: scroll;
}

.order-list {
  max-height: calc(100vh - 275px);
  overflow: scroll;
}

</style>
<script lang="ts">


import {Media} from '@/models/Media'
import {DataArray} from '@/models/Response'
import {Route, RouteConst} from '@/models/Route'
import {Truck} from '@/models/Truck'
import Helper, {date_format_mysql} from '@/services/Helper'
import {Component, Vue} from 'vue-property-decorator'
import draggable from 'vuedraggable'
import TypeBadge from '../components/Customer/TypeBadge.vue'
import StatusBadge from '../components/Route/StatusBadge.vue'

@Component({
  components: {TypeBadge, StatusBadge, draggable}
})
export default class RouteEditorDialog extends Vue {

  route = new Route()
  open = false
  isLoadRoute = false
  isLoadCalculateRoute = false
  isLoadSubmitRoute = false
  export_drop: any = {}

  RouteConst = RouteConst

  isDirty = false
  dragging: false

  optimized: any = []
  // dragOptions = {
  //   animation: 200,
  //   group: 'description',
  //   disabled: false,
  //   ghostClass: 'ghost',
  // }
  ref_route = null
  trucks: Truck[] = []

  get lDate() {
    if (this.route.load_at)
      return Math.ceil((new Date(this.route.load_at).getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24))
    return -1
  }


  get tDate() {
    if (this.route.start_at)
      return Math.ceil((new Date(this.route.start_at).getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24))
    return -1
  }

  onApply: Function = () => {

  }


  onOpen({export_drop, ref_route, onApply}) {
    if (this.open) return
    console.log('Emited', {export_drop})


    this.ref_route = ref_route
    if (ref_route) {
      this.route = ref_route
    } else {
      this.route = new Route()
    }

    this.export_drop = export_drop
    this.optimized = export_drop.optimized

    this.ImportDraft()
    this.refreshTruck()

    console.log('open')
    this.open = true

    this.onApply = onApply
  }

  mounted() {
    this.$root.$on('openRouteEditor', this.onOpen)

    // const export_drop =
    //     {
    //       'datetime_from': '2021-12-03 08:00:00',
    //       'truck': {
    //         'id': 4,
    //       },
    //       'optimized': [
    //         {
    //           'code': 'SOTT-211100513',
    //           'lat': 16.82,
    //           'lng': 102.204,
    //           'weight': 114.2,
    //           'volume': 0.262143,
    //           'worth': 4912,
    //           'district_id': '400604',
    //         },
    //         {
    //           'code': 'SOTT-211100543',
    //           'lat': 16.613,
    //           'lng': 102.878,
    //           'weight': 52.2,
    //           'volume': 0.091188,
    //           'worth': 4032,
    //           'district_id': '400710',
    //         },
    //         {
    //           'code': 'SOPJ-211100457',
    //           'lat': 16.728,
    //           'lng': 102.862,
    //           'weight': 120.63333333333,
    //           'volume': 0.22339717,
    //           'worth': 6058.1,
    //           'district_id': '400702',
    //         },
    //         {
    //           'code': 'SOTT-211100435',
    //           'lat': 16.73,
    //           'lng': 102.897,
    //           'weight': 81.6,
    //           'volume': 0.12852,
    //           'worth': 5232,
    //           'district_id': '400703',
    //         },
    //         {
    //           'code': 'SOTT-211100404',
    //           'lat': 16.73,
    //           'lng': 102.897,
    //           'weight': 57.4,
    //           'volume': 0.13586334,
    //           'worth': 2294.4,
    //           'district_id': '400703',
    //         },
    //         {
    //           'code': 'SOTT-211100428',
    //           'lat': 16.92804617585,
    //           'lng': 103.63601749162,
    //           'weight': 270.6,
    //           'volume': 0.58962891,
    //           'worth': 8075.9,
    //           'district_id': '461001',
    //         },
    //         {
    //           'code': 'SOTT-211100386',
    //           'lat': 17.356,
    //           'lng': 103.856,
    //           'weight': 487.25066666667,
    //           'volume': 1.1383366933333,
    //           'worth': 19184,
    //           'district_id': '470401',
    //         },
    //         {
    //           'code': 'SOTT-211100385',
    //           'lat': 17.350606198588,
    //           'lng': 103.84900416336,
    //           'weight': 182.4,
    //           'volume': 0.37711034,
    //           'worth': 5785.6,
    //           'district_id': '470401',
    //         },
    //         {
    //           'code': 'SOPJ-211100412',
    //           'lat': 17.353552766084,
    //           'lng': 103.84605153917,
    //           'weight': 99.3,
    //           'volume': 0.17779667,
    //           'worth': 2419.2,
    //           'district_id': '470401',
    //         },
    //         {
    //           'code': 'SOTT-211100368',
    //           'lat': 17.39,
    //           'lng': 103.704,
    //           'weight': 105.2,
    //           'volume': 0.19973468,
    //           'worth': 5492.8,
    //           'district_id': '470501',
    //         },
    //         {
    //           'code': 'SOTT-211100506',
    //           'lat': 17.628060701758,
    //           'lng': 104.25291193035,
    //           'weight': 584.1,
    //           'volume': 1.19156479,
    //           'worth': 24214.2,
    //           'district_id': '480801',
    //         },
    //         {
    //           'code': 'SOTT-211100480',
    //           'lat': 17.960105836417,
    //           'lng': 104.21800592729,
    //           'weight': 516.9,
    //           'volume': 1.00114871,
    //           'worth': 20486.4,
    //           'district_id': '480401',
    //         },
    //         {
    //           'code': 'SOTT-211100358',
    //           'lat': 18.023879864018,
    //           'lng': 103.70572278351,
    //           'weight': 85.5,
    //           'volume': 0.19165125,
    //           'worth': 4524,
    //           'district_id': '380203',
    //         },
    //         {
    //           'code': 'SOTT-211100432',
    //           'lat': 17.568,
    //           'lng': 103.561,
    //           'weight': 27.2,
    //           'volume': 0.04284,
    //           'worth': 1744,
    //           'district_id': '471602',
    //         },
    //         // {
    //         //   'code': 'SOPJ-211100557',
    //         //   'lat': 17.448,
    //         //   'lng': 103.462,
    //         //   'weight': 13.6,
    //         //   'volume': 0.02142,
    //         //   'worth': 872,
    //         //   'district_id': '471201',
    //         // },
    //       ],
    //     }
    // this.onOpen({
    //   export_drop: export_drop, onApply: () => {
    //   },
    // })

  }

  async confirmRecalPath() {
    this.$confirm('คำนวนใหม่ อาจจะใช้เวลานาน?').then(res => {
      if (res) {
        this.ImportDraft(true)
      }
    })
  }

  async ImportDraft(recal_path = false) {

    let route: Route = new Route()
    route.truck_id = this.route.truck_id
    route.load_at = this.route.load_at
    route.start_at = this.route.start_at
    route.export_drop = this.export_drop
    route.export_drop.optimized = this.optimized
    route.export_drop.datetime_from = route.start_at
    route.export_drop.truck.id = this.route.truck_id
    if (recal_path) {
      route.recal_path = recal_path
    }

    if (!route.hasOwnProperty('ImportDraft')) {
      route = Object.setPrototypeOf(route, Route.prototype)
    }
    this.isLoadCalculateRoute = true

    try {
      const routeExe = await route.ImportDraft()
      if(routeExe) {
        this.route = routeExe
        this.export_drop = this.route.export_drop
        this.optimized = this.route.export_drop.optimized
        this.isDirty = false
      }else{
        this.$root.$emit('onError', {message: "คำนวนผิดพลาดกรุณาลองอีกครั้ง"})
      }
      // this.route = null;
    } catch (e) {
      // alert(e);
    }
    this.isLoadCalculateRoute = false
  }

  async ConfirmRoute() {

    let route: Route = new Route()
    // debugger
    route.truck_id = this.route.truck_id
    route.load_at = this.route.load_at
    route.start_at = this.route.start_at
    route.export_drop = this.export_drop
    route.export_drop.optimized = this.optimized
    route.export_drop.datetime_from = route.start_at
    route.export_drop.truck.id = this.route.truck_id

    if (!route.hasOwnProperty('ImportDraft')) {
      route = Object.setPrototypeOf(route, Route.prototype)
    }
    this.isLoadSubmitRoute = true
    // debugger
    try {
      console.log(route)
      this.route = await route.ConfirmRoute()
      // console.log(this.onApply)
      this.onApply && this.onApply()
      this.close()

      // this.$root.$emit('onSuccess', {message: 'ส่งทริปเรียบร้อย'})
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.isLoadSubmitRoute = false
  }

  close() {
    this.open = false
  }

  add(index) {
    this.$root.$emit('openOrderPicker', {
      existingCode: this.optimized.map(action => action.code),
      onApply: (destination: any) => {
        if (this.route && this.route.districts && !this.route.districts[destination.district_id]) {

          this.route.districts[destination.district_id] = destination.district
        }

        this.optimized.splice(index, 0, destination)
        this.export_drop['optimized'] = this.optimized
        this.isDirty = true
      }
    })
  }

  replace() {

  }

  remove(index) {
    this.optimized.splice(index, 1)
    this.export_drop['optimized'] = this.optimized
    this.isDirty = true
  }

  checkMove(e) {
    this.isDirty = true
  }

  async refreshTruck() {
    const url = Helper.setting.truck.getListAPI

    try {
      this.isLoadSubmitRoute = true
      this.trucks = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.isLoadSubmitRoute = false
  }

};

</script>
